/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* Title: HTTP Request Wrapper
 * Description: GET, POST, PUT, DELETE Wrapper
 * Author: Majeed
 * Date: 2022-03-03
 */
import { media_API_V2 } from '../api/ENDPOINTS/products';
import http from './http';

// HTTP-GET
export function getRequest(endpoint, queryString = '') {
    return http
        .get(`${endpoint}`)
        .then((res) => res)
        .catch((err) => err);
}

// HTTP-POST
export function postRequest(endpoint, formData) {
    return http
        .post(endpoint, formData)
        .then((res) => res)
        .catch((err) => err);
}

// HTTP-PUT
export function putRequest(endpoint, id, data) {
    return http
        .put(`${endpoint}/${id}`, data)
        .then((res) => res)
        .catch((err) => err);
}

// HTTP-PATCH
export function patchRequest() {
    //
}

// HTTP-DELETE
export function deleteRequest(endpoint) {
    return http.delete(endpoint);
}

/**
 * misc. requests
 */

// upload media...
export function uploadMedia(data) {
    http.defaults.headers.common['Content-Disposition'] = `attachment; filename="${data.name}"`;
    return http
        .post(media_API_V2, data)
        .then((res) => res)
        .catch((err) => err);
}
